import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PatientService } from '../../../service/patient-service/patient.service';
import { decryptField } from '../../../utils/decrypt-utils';
import { getReservationStatus } from '../../../utils/placement-status';

@Component({
  selector: 'app-patient',
  templateUrl: './patient.component.html',
  styleUrls: ['./patient.component.css']
})
export class PatientComponent implements OnInit {

  patients: any[] = [];
  isLoading: boolean = false;
  search: string = '';
  selectedMemberId: string = null;
  selectedReservationId: number | string | null = null;
  selectedReferenceId: string | null = null;
  activeDropdownPatientId: any = null;

  constructor(
    private patientService: PatientService,
    private router: Router
  ) { }

  ngOnInit() {
    this.getPatientsList();
  }

  openMemberModal(memberId: string) {
    if (memberId) {
      this.selectedMemberId = memberId;
    }
  }

  onCreateAssist(patient: any) {
    this.router.navigate(['/placement/assists/create'], {
      queryParams: {
        patientId: patient.id || patient._id || '',
        patientName: `${patient.first_name || ''} ${patient.last_name || ''}`.trim(),
        intakeId: patient.e_intakes && patient.e_intakes.length ? (patient.e_intakes[0].id || patient.e_intakes[0]._id || '') : ''
      }
    });
  }

  onAddPatient() {
    this.router.navigate(['/placement/patient/add']);
  }

  getPatientsList() {
    this.isLoading = true;
    this.patientService.getPatients().subscribe(
      (response: any) => {
        let rawPatients = [];
        if (response && response.data) {
          rawPatients = response.data;
        } else if (Array.isArray(response)) {
          rawPatients = response;
        } else {
          rawPatients = response.patients || [];
        }
        
        this.patients = rawPatients.map((patient: any) => ({
          ...patient,
          first_name: decryptField(patient.first_name),
          last_name: decryptField(patient.last_name),
          phone: decryptField(patient.phone),
          reference_id: decryptField(patient.reference_id),
          reference_name: decryptField(patient.reference_name),
          reference_phone: decryptField(patient.reference_phone)
        }));

        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching patients:', error);
        this.isLoading = false;
      }
    );
  }

  noBookingStatus(patient: any): number {
    if (!patient) return -1;

    if (patient.max_booking_id === null) {
      return 1;
    }

    const statusId = Number(patient.max_onboarding_status_id);
    if (statusId === 8) {
      return 2;
    }

    if (statusId === 15) {
      return 3;
    }

    if (statusId === 7) {
      return 4;
    }

    return 0;
  }

  getBookingStatus(patient: any): string {
    const statusId = patient && patient.max_onboarding_status_id;
    if (!statusId) return '-';
    const statusObj = getReservationStatus(Number(statusId));
    return statusObj ? statusObj.label : '-';
  }

  getBookingStatusColor(patient: any): string {
    const statusId = patient && patient.max_onboarding_status_id;
    if (!statusId) return '#6b7280';
    const statusObj = getReservationStatus(Number(statusId));
    return statusObj ? statusObj.color : '#6b7280';
  }

  showBookingReservation(patient: any): boolean {
    return this.noBookingStatus(patient) === 0;
  }

  showAssistDetails(patient: any): boolean {
    if (!patient) return false;
    const broadcastDetails = patient.e_patientbroadcastdetails;
    return !!(broadcastDetails && broadcastDetails.length > 0);
  }

  openReservationModal(patient: any): void {
    if (patient && patient.max_booking_id) {
      this.selectedReservationId = patient.max_booking_id;
    }
  }

  closeReservationModal(): void {
    this.selectedReservationId = null;
  }

  openAssistModal(patient: any): void {
    if (patient && patient.e_patientbroadcastdetails && patient.e_patientbroadcastdetails.length > 0) {
      const assist = patient.e_patientbroadcastdetails[0];
      const refId = assist.reference_id || assist.id;
      if (refId) {
        this.selectedReferenceId = String(refId);
      }
    }
  }

  closeAssistModal(): void {
    this.selectedReferenceId = null;
  }

  canCreateAssist(patient: any): boolean {
    if (!patient) return false;

    const bookingStatus = this.noBookingStatus(patient);
    return (
      bookingStatus === 1 || bookingStatus === 2 || bookingStatus === 3 || bookingStatus == 4
    );
  }

  toggleDropdown(patient: any, event: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    const patientId = patient ? (patient.id || patient._id) : null;
    if (this.activeDropdownPatientId === patientId) {
      this.activeDropdownPatientId = null;
    } else {
      this.activeDropdownPatientId = patientId;
    }
  }

  closeDropdown(patient: any): void {
    const patientId = patient ? (patient.id || patient._id) : null;
    if (this.activeDropdownPatientId === patientId) {
      this.activeDropdownPatientId = null;
    }
  }

}
